import 'slick-carousel';

const heroSlider = () => {
	const $container = $('.js-slider');

	if ( ! $container.length ) {
		return;
	}
	
	let $heroSlider = $container.find('.slider__slides');

	$heroSlider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		dots: false,
		prevArrow: $('.slider__prev'),
		nextArrow: $('.slider__next'),
		autoplay: true,
		autoplaySpeed: 6000,
		pauseOnHover: false,
	});
}

heroSlider();
